import {Component} from '@angular/core';
import {WaDividerDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-rt-layers',
	templateUrl:'./CommunicationLayersPage.html',
	styles: [],
	styleUrls:['./CommunicationLayersPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		WaDividerDirective,
		WaTextDirective,
		MarkdownComponent,
],
	standalone:true
})
export class CommunicationLayersPage
{
	mdContent_137 = `\`\`\`plain
  REQUEST / RESPONSE (always available)
  ┌─────────────────────────────────────────────┐
  │  REST Endpoints     @Path @GET @POST        │  ← Jakarta RS on Vert.x
  │  AJAX Events        OnClickAdapter, etc.    │  ← 50+ server-driven events
  │  Data Services      @NgDataService           │  ← Typed Angular services
  └─────────────────────────────────────────────┘

  REAL-TIME (opt-in when you need it)
  ┌─────────────────────────────────────────────┐
  │  Vert.x Event Bus   Built-in STOMP/WS       │  ← Zero infrastructure
  │  RabbitMQ Comms     Broker-backed STOMP/WS   │  ← Production scale
  └─────────────────────────────────────────────┘
\`\`\``;
}
